//映恩生物

import FloatingPC from '@/rebuild/materials/shared/floating/YingEnshengwuBaseFloatingPC.vue';
import FloatingMobile from '@/rebuild/materials/shared/floating/YingEnshengwuBaseFloatingMobile.vue';

export const componentMap = {
	basic: FloatingPC,
	'basic-mobile': FloatingMobile
};